<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="付款申请" v-if="findChildren(102)!==-1" name="paymentapplication" style="height: 100%;">
				<paymentapplication-index />
			</el-tab-pane>
			<el-tab-pane label="退收款单" v-if="findChildren(153)!==-1" name="paymentapplicationtsk" style="height: 100%;">
				<paymentapplicationtsk-index />
			</el-tab-pane>
			<el-tab-pane label="付款待开票" v-if="findChildren(129)!==-1" name="paymentapplicationinvoice" style="height: 100%;">
				<paymentapplicationinvoice-index />
			</el-tab-pane>	
			<el-tab-pane label="供应商发票" v-if="findChildren(128)!==-1" name="supplierinvoice" style="height: 100%;">
				<supplierinvoice-index />
			</el-tab-pane>			
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import paymentapplicationIndex from './paymentapplication/index.vue'
	import paymentapplicationtskIndex from './paymentapplicationtsk/index.vue'
	import paymentapplicationinvoiceIndex from './paymentapplicationinvoice/index.vue'
	import supplierinvoiceIndex from './supplierinvoice/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				//this.activeName = 'purchasestockbill'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			paymentapplicationIndex,
			paymentapplicationtskIndex,
			paymentapplicationinvoiceIndex,
			supplierinvoiceIndex

		}
	}
</script>